/**
 * Amplitude helpers for registry / gifting-page share flows.
 */
import { logEvent } from './analytics';

/** User tapped a share entry point (plan card, home, plan detail). */
export function logShareClick({ source, share_type, plan_id } = {}) {
    logEvent('share: click share button', {
        source,
        share_type,
        ...(plan_id != null ? { plan_id: Number(plan_id) } : {}),
    });
}

/** Share overlay opened with copy / email / text channel options. */
export function logShareOverlayOpen({ source, share_type, plan_id } = {}) {
    logEvent('share: open overlay', {
        source,
        share_type,
        ...(plan_id != null ? { plan_id: Number(plan_id) } : {}),
    });
}
